import React, { useEffect, useRef, useState } from 'react';
import MapInstance from './layers/map';
import styles from './Map.module.less'
import UserLayer from './layers/user'
import FenceLayer from './layers/fence';
import { getUrlParam, IUrlParam, worldToMap } from '@common/index'
import Api from '@server/api'
import ApiUrl from '@server/apiUrl'
import { Dialog, Toast } from 'antd-mobile'
import _ from 'lodash';

const MapComponent = () => {
	const mapVector = useRef<MapInstance>();
	const userVectorLayer = useRef<UserLayer>(); // 保洁图层
	const fenceVectorLayer = useRef<FenceLayer>(); // 保洁图层

	const [isIcsReport, setIsIcsReport] = useState(false)
	const [mapName, setMapName] = useState('')
	useEffect(() => {
		const param = getUrlParam();
		const { isReport = 'false' } = param
		const report = isReport === 'false' ? false : true
		setIsIcsReport(report)
		initRequest(param)
	}, []);

	const initRequest = async (param: IUrlParam) => {
		try {
			Toast.show({
				position: 'top',
				icon: 'loading'
			})
			const locateRes = await Api.getRequest(ApiUrl.personCurrentLocation + `?personId=${param.personId}`)
			const person = _.get(locateRes, ['personPositionTrack','person'], '')
			const localMapUuid = _.get(locateRes, ['personPositionTrack','positionTrack', 'localMapUuid'], '')
			let timer;
			let pictureRes = await Api.getRequest(ApiUrl.mapMetaDataAndPicture + `?localMapUuid=${localMapUuid}`)
			const mapInfo = _.get(pictureRes, ['mapMetaData', 'mapInfo'], {});
			const mapName = _.get(pictureRes, ['mapMetaData', 'name'], '');
			setMapName(mapName);
			const mapId =  _.get(pictureRes, ['mapId'], {});
			// 加载地图
			mapVector.current = new MapInstance(pictureRes);
			// user层
			userVectorLayer.current = new UserLayer(mapVector.current.extent, person)
			mapVector.current.map.addLayer(userVectorLayer.current.layer)
			const x = _.get(locateRes, ['personPositionTrack','positionTrack', 'coordinate', 'x'], 0)
			const y = _.get(locateRes, ['personPositionTrack','positionTrack', 'coordinate', 'y'], 0)
			const points = worldToMap(x, y, mapInfo)
			// fence 层
			fenceVectorLayer.current = new FenceLayer(mapVector.current.extent)
			mapVector.current.map.addLayer(fenceVectorLayer.current.layer)
			const fenceUrl = ApiUrl.queryMapFence.split(':')[0]+mapId+':'+ ApiUrl.queryMapFence.split(':')[1]
			const fenceData:any = await Api.getRequest(fenceUrl)
			// const mockData = JSON.parse('{"id":"5524d903-a6a0-4a92-a928-7d98df51e28d","name":"fences/5524d903-a6a0-4a92-a928-7d98df51e28d","mapId":"aa63e0c9-5412-11ed-bbe7-536b7298fe2a","mapVersionId":"000988b8-5413-11ed-bbe7-2fbe5d88e49e","geoJson":{"type":"FeatureCollection","features":[{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-14.574999998137356,0.5750000666826964],[-14.624999998882414,-1.374999962374568],[-12.774999971315266,-1.374999962374568],[-11.424999951198698,-1.374999962374568],[-11.12499994672835,1.6250000823289157],[-14.47499999664724,1.825000085309148],[-14.574999998137356,0.5750000666826964]]]},"properties":{"id":"a44949da-7ba4-40dc-83e3-8174c809de06","name":"a1","type":"polygons","floor":"","siteType":"OFFICE_BUILDING","fenceType":"TRASH_CAN","timeFrame":"11:40-16:40"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-7.224999888613821,2.0750000890344382],[-7.024999885633589,-1.1249999586492776],[-1.7249998066574346,2.875000100955367],[-7.224999888613821,2.0750000890344382]]]},"properties":{"id":"2b11d34e-d39e-405f-b127-09266e272caa","name":"a2","type":"polygons","floor":"","siteType":"PARKING_LOT","fenceType":"ESCALATOR","timeFrame":"11:40-16:40"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[5.175000296160578,0.32500006295740613],[5.12500029541552,0.7250000689178706],[5.0250002939254035,1.125000074878335],[4.825000290945171,1.4750000800937415],[4.575000287219881,1.77500008456409],[4.275000282749533,2.02500008828938],[3.925000277534126,2.2250000912696124],[3.57500027231872,2.3250000927597285],[3.1750002663582553,2.3750000935047866],[2.775000260397791,2.3250000927597285],[2.3750002544373263,2.2250000912696124],[2.02500024922192,2.02500008828938],[1.7250002447515715,1.77500008456409],[1.4750002410262812,1.4750000800937415],[1.325000238791107,1.125000074878335],[1.1750002365559329,0.7250000689178706],[1.1250002358108748,0.32500006295740613],[1.1750002365559329,-0.07499994300305834],[1.325000238791107,-0.4249999482184648],[1.4750002410262812,-0.7749999534338712],[1.7250002447515715,-1.0749999579042195],[2.02500024922192,-1.3249999616295098],[2.3750002544373263,-1.524999964609742],[2.775000260397791,-1.6249999660998582],[3.1750002663582553,-1.6749999668449165],[3.57500027231872,-1.6249999660998582],[3.925000277534126,-1.524999964609742],[4.275000282749533,-1.3249999616295098],[4.575000287219881,-1.0749999579042195],[4.825000290945171,-0.7749999534338712],[5.0250002939254035,-0.4249999482184648],[5.12500029541552,-0.07499994300305834],[5.175000296160578,0.32500006295740613]]]},"properties":{"id":"d14cdc6e-fa5f-438f-a8e7-b13ce9364b25","name":"a3","type":"circles","floor":"","center":{"x":3.1750002663582553,"y":0.32500006295740613},"radius":40,"siteType":"PEDESTRIAN_STREET","fenceType":"ESCALATOR","timeFrame":"11:40-16:40"}}]},"sourceType":"WEB","creator":"superadmin","updater":"superadmin","deleted":false,"createTime":"2022-11-08T03:42:12Z","updateTime":"2022-11-08T03:42:12Z"}')
			// console.log('res===fenceData', fenceData);

			mapVector.current.bgSource.on("imageloadend", (res: any) => {
				userVectorLayer.current!.addFeature(points)
				// fenceVectorLayer.current!.dataDrawShapeFence(mockData.geoJson.features, mapInfo)
				fenceVectorLayer.current!.dataDrawShapeFence(fenceData.geoJson.features, mapInfo)
			});
			if(timer) clearInterval(timer);
			timer=setInterval(async ()=>{
				pictureRes = await Api.getRequest(ApiUrl.mapMetaDataAndPicture + `?localMapUuid=${localMapUuid}`)
				const x = _.get(locateRes, ['personPositionTrack','positionTrack', 'coordinate', 'x'], 0)
				const y = _.get(locateRes, ['personPositionTrack','positionTrack', 'coordinate', 'y'], 0)
				const points = worldToMap(x, y, mapInfo)
				userVectorLayer.current!.removeFeature()
				userVectorLayer.current!.addFeature(points)
			},3000)
			Toast.clear()
		} catch (error) {
			Toast.clear()
			// alert(JSON.stringify(error));
			Dialog.alert({
				content: '地图获取失败',
				closeOnMaskClick: false,
				confirmText:'确定',
				onConfirm:()=>{
					if (!window.uni) return
					window.uni.webView.navigateBack({
						animationType: "none",
					})
				}
			})
		}
	}

	const btnClick = () => {
		if (!window.uni) return
		window.uni.webView.postMessage({
			data: {
				action: 'message'
			}
		});
		window.uni.navigateTo({
			url:'/pages/work/report'
		})
		// window.uni.webView.navigateBack({
		// 	animationType: "none",
		// })
	}

	return (
		<>
			<div className={styles.mapName}>{mapName}</div>
			<div id="openlayerMap" className={styles.openlayerMap}></div>
			{!!isIcsReport ? (
				<div className={styles.btn}>
					<div onClick={btnClick}>我要报事</div>
				</div>
			) : null}
		</>
	);
};

export default MapComponent;
